import React, { useState } from 'react'
import styled from 'styled-components'

import { TabContent, TabPane } from 'reactstrap'

import { ToggleTabs } from './toggle-tabs'
import { TabPaneChangeRequest } from './tab-pane-change-request'
import { TabPaneOtherService } from './tab-pane-other-service'
import { TabPaneLicensing } from './tab-pane-licensing'
import { TabPaneHardware } from './tab-pane-hardware'

export const CostPlanningTab = props => {
  const [activeTab, setActiveTab] = useState(0)

  const {
    data: {
      vendors,
      licenses,
      hardwares,
      change_requests,
    },
    crType,
    handleInput,
  } = props

  return (
    <Root>
      <ToggleTabs
        activeTab={ activeTab }
        setActiveTab={ setActiveTab }
      />
      <TabContent activeTab={ activeTab }>
        { activeTab === 0 &&
        <TabPane tabId={ 0 }>
          <TabPaneOtherService vendors={ vendors } handleInput={ handleInput } />
        </TabPane>
        }
        { activeTab === 1 &&
        <TabPane tabId={ 1 }>
          <TabPaneLicensing licenses={ licenses } handleInput={ handleInput } />
        </TabPane>
        }
        { activeTab === 2 &&
        <TabPane tabId={ 2 }>
          <TabPaneHardware hardwares={ hardwares } handleInput={ handleInput } />
        </TabPane>
        }
        { activeTab === 3 &&
        <TabPane tabId={ 3 }>
          <TabPaneChangeRequest
            crType={ crType }
            changeRequests={ change_requests }
            handleInput={ handleInput }
          />
        </TabPane>
        }
      </TabContent>
    </Root>
  )
}

const Root = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #F1F1F1;
`



// WEBPACK FOOTER //
// ./src/components/project-code/project-detail/cost-planning/index.js